import React, { Component } from 'react';
import { Card } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';

import DescriptionList from '@comm/DescriptionList';
import TableFile from '../../comm/TableFile';
import TipsOverdue from '../../comm/TipsOverdue';
import TableAppoint from '../station/TableAppoint';

const { Description } = DescriptionList;
class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  findTypeName = type => {
    let typeName = '';
    this.props.expendType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  handleVisible = flag => {};

  render() {
    const { dataItem } = this.state;
    const { business } = dataItem;
    const { payables } = this.props;
    const extra = <TipsOverdue interval={dataItem.interval} />;
    return (
      <div className="form-open mb16">
        <Card title={extra}>
          <DescriptionList size="large" col={3}>
            <Description term="合同编号">{business.no}</Description>
            <Description term="孵化器">{business.incubator}</Description>
            <Description term="客户">{business.custom}</Description>
            <Description term="项目">{business.projectName}</Description>
            <Description term="收入类型">
              {business.type === 'settled' ? <span>工位注册</span> : null}
              {business.type === 'oregistapp' ? <span>地址注册</span> : null}
            </Description>
            {dataItem.businessPrice ? (
              <Description term="合同费用">{business.businessPrice}</Description>
            ) : null}
            {dataItem.deposit ? <Description term="押金">{business.deposit}</Description> : null}
            <Description term="合同费用">{business.businessPrice}</Description>
            <Description term="押金">{business.deposit}</Description>
            <Description term="地址数量">{business.num}</Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="使用地址详情">
              <div>
                {(business.addresses || []).map(item => {
                  return <div key={item.uuid}>{item.name}</div>;
                })}
              </div>
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={3}>
            <Description term="记租时间">
              {moment.unix(business.beginDate / 1000).format('YYYY-MM-DD')}
            </Description>
            <Description term="到期时间">
              {moment.unix(business.endDate / 1000).format('YYYY-MM-DD')}
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={3}>
            <Description term="终止开始时间">
              {moment.unix(dataItem.beginDate / 1000).format('YYYY-MM-DD')}
            </Description>
            <Description term="终止结束时间">
              {moment.unix(dataItem.endDate / 1000).format('YYYY-MM-DD')}
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={1}>
            <Description term="附件">
              <TableFile dataSource={dataItem.files || []} disabled />
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="终止合同说明">{dataItem.reason}</Description>
          </DescriptionList>
          <div>
            {payables && payables.length > 0 ? <TableAppoint data={payables || []} /> : null}
          </div>
        </Card>
      </div>
    );
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/incubator/termination/address/FormOpen.js